import { createFileRoute, Outlet } from "@tanstack/react-router";

function OperacionesLayout() {
  return <Outlet />;
}

/** Layout: hub + proveedores, compras, recompras. Órdenes → /app/pedidos */
export const Route = createFileRoute("/app/operaciones")({
  component: OperacionesLayout,
});
